export const USER_AGREEMENT = {
    title: '上海屋聚网络平台用户使用协议',
    abstraction: '上海屋聚公共租赁住房运营有限公司（以下简称“上海屋聚”）在此特别提醒，为了保护用户的权益，请于注册或使用本账户前，详细阅读本“上海屋聚用户注册协议”条款所有内容，特别是其中所涉及的与用户的权益具有重大关系的条款，免除、减轻上海屋聚责任的条款；以上条款可能以黑体加粗的形式进行提示。请用户审慎阅读并选择接受或不接受本协议。除非用户接受本协议所有条款，否则用户无权使用上海屋聚于本协议下所提供的服务。当用户注册或使用账户时，即表示用户已阅读、了解并同意接受本协议之所有内容，本协议在用户和上海屋聚间具有合同上的法律效力。',
    protocols: [
        {
            name: '一、账户注册',
            list: [
                { text: '（一）用户应具有法律规定的完全民事权利能力和行为能力，且为能够独立承担民事责任的自然人、法人或其他组织或机构。若用户不具备前述条件，应立即停止注册和使用账户。' },
                { text: '（二）用户应使用真实身份信息注册并使用账户，并依注册要求提供用户的正确、完整、有效的相关资料（下称注册信息），用户不得冒用或妨碍其他组织、机构或个人注册使用账户。用户有义务维护和更新自己的注册信息，确保其持续的准确性、完整性和有效性，并承担因用户的注册信息缺失、陈旧或不真实而造成的任何损失，用户具有上述情况之一的，上海屋聚有权暂停或终止为用户提供任何账户服务。' },
                { text: '（三）上海屋聚有权通过银行或其他第三方机构验证用户的注册信息，并有权通过第三方获得用户相关信息。' },
                { text: '（四）根据监管机构要求，为了保障用户资金的安全，部分账户功能需要用户进行账户身份认证后方能使用。' }
            ]
        },
        {
            name: '二、账户服务',
            list: [
                { text: '（一）付款。用户的上海屋聚账户在登录状态下发出的支付指令均视为用户本人/本单位发出的支付指令。上海屋聚根据用户的支付指令，将资金付至用户所指定的其他的上海屋聚合作商户或用户。' },
                { text: '（二）提现。用户随时可申请提领上海屋聚代为保管的资金，上海屋聚应将代为保管的资金划转至用户在上海屋聚预留的提现银行账户。' },
                { text: '（三）购买积分。用户可使用上海屋聚提供的网上支付渠道为用户的账户购买积分，积分可用于置顶房源，后续或将开通更多积分功能。' },
                { text: '（四）在用户完成账户身份认证之前，用户将无法使用账户提现、付款及其他需要账户身份认证的账户功能。' },
                { text: '（五）如无其他特别约定，上海屋聚代为保管的资金不产生任何形式的利息。' },
                { text: '（六）上海屋聚根据《电子合同法》的内容，为用户提供电子版租赁合同并保证其有效合法性。个人有义务保管好自己的帐号和密码，确认真实身份，通过系统签约，即视为本人签订。用户对本人/单位发出的支付指令承担全部法律责任。' }
            ]
        },
        {
            name: '三、隐私信息保护',
            list: [
                { text: '（一）隐私信息指用户在注册账户所提供的全部注册信息及用户使用账户所产生时具体交易信息。' },
                { text: '（二）上海屋聚会根据需要，按照所提供的不同服务类别向用户收集不同的个人信息。所需要收集的内容都会在相关页面上明示，包括但不限于用户的姓名、性别、手机号码、身份证资料、银行卡信息等。但上海屋聚将保证对用户的隐私信息进行严格的管理及保护，防止用户的隐私信息泄露或被盗用。' },
                { text: '（三）为有针对性地向用户提供新的服务和机会，用户了解并同意上海屋聚及其关联公司向其发送相关通知。' },
                { text: '（四）除法律规定，司法机关、业务监管机构及商业银行的调查外，上海屋聚不得在履行本协议的需要以外使用用户的隐私信息。' },
                { text: '（五）上海屋聚仅按现有技术提供相应的安全措施来使本公司掌握的信息不丢失，不被滥用和变造。这些安全措施包括向其它服务器备份数据和对用户密码加密。尽管有这些安全措施，但在现有技术发展下上海屋聚不保证这些信息的绝对安全。' }
            ]
        },
        {
            name: '四、用户的权利与义务',
            list: [
                { text: '（一）用户有义务妥善保管注册信息如手机设备，并持续保持对上海屋聚账号、密码、短信验证码等信息资料，因用户泄露、遗失、复制、转交前述信息和资料等保管不当行为所产生的一切损失由用户自行承担，并赔偿因此给上海屋聚或其他主体造成的损失。' },
                { text: '（二）用户有义务正确使用账户，账户仅限用户使用，不得向任何其他第三方出售、出租、转让或者以其他形式进行有偿或无偿转让，也不得向任何其他第三方提供账户使用。若因上述情况或不当使用造成损失的，上海屋聚不承担相关责任，由用户自行承担。' },
                { text: '（三）用户有义务合理合法的使用账户，不得从事任何违反法律、法规等具有约束力的规范性文件的行为（包括但不限于进行没有真实交易的购买积分、转账与提现等行为）；不得对账户使用过程中的任何计算机数据进行拦截、破解、篡改或对账户服务系统进行非正常的登录。用户不得利用上海屋聚所提供的服务从事以下行为，否则上海屋聚有权拒绝提供服务，且用户应承担所有相关法律责任，因此导致上海屋聚或其他方受损的，用户应承担赔偿责任：', details: [
                    '反对宪法所确定的基本原则，危害国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一的；',
                    '侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权、其他知识产权及其他合法权益；',
                    '违反依法律或本协议所应负的保密义务；',
                    '冒用他人名义使用财付通服务或电话号码与身份证号无法一一对应的；',
                    '从事任何不法交易行为，如贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、在网上买卖POS机（包括MPOS）、刷卡器等受理终端，或其他违禁物；',
                    '提供赌博资讯或以任何方式引诱他人参与赌博；',
                    '涉嫌洗钱、恐怖融资、套现或进行传销活动的；',
                    '使用无效信用卡号码或非法使用他人信用卡号码进行交易；',
                    '使用无效银行账户或非法使用他人银行账户交易；',
                    '进行与用户或交易对方宣称的内容不符的交易或不真实的交易；',
                    '出租、出借、出售、购买银行账户或者支付账户，假冒他人身份或者虚构代理关系开立银行账户或者支付账户；',
                    '从事任何可能含有电脑病毒或是可能侵害上海屋聚系统、资料之行为；',
                    '其他违法行为或上海屋聚有正当理由认为不适当的行为包括以任何形式收取中介费。'
                ] },
                { text: '（四）在发生任何涉嫌违法交易时，用户有义务根据司法机关、银行及上海屋聚的要求提供涉嫌违法交易的相关证明。' },
                { text: '（五）用户有权通过使用账户与其他上海屋聚商户或用户之间进行合法交易，并自行对网上交易及由此产生的一切后果承担民事法律责任。' },
                { text: '（六）用户有权自行查询账户余额和使用情况，并定期保存交易历史记录。用户应在账户和密码因任何原因受到潜在或现实危险时，立即和上海屋聚取得联系，在上海屋聚采取行动前，上海屋聚对此不负任何责任。' }
            ]
        },
        {
            name: '五、上海屋聚的权利与义务',
            list: [
                { text: '（一）上海屋聚有义务承担账户系统稳定运行的责任，向用户提供本协议所约定之各项服务。对支付系统的信息处理过程中的安全、保密、及时性负责。' },
                { text: '（二）上海屋聚有义务保障用户账户中的资金独立存放，与上海屋聚自有资金及其他用户资金相区分。非经用户的许可、授权或法律的规定，不得动用。' },
                { text: '（三）上海屋聚有权基于交易安全和系统维护的需要，在预先通过网站公示的情形下，对交易系统进行计划性的停机。' },
                { text: '（四）上海屋聚有权对交易风险事件进行独立判断，在用户涉嫌进行违法交易或违反本协议约定时，上海屋聚有权对用户的账户进行限额交易、止付、停止服务，直至关闭账户，必要时有权移交司法机关处理。' },
                { text: '（五）上海屋聚有权了解用户使用产品或服务的真实交易背景及目的，如果上海屋聚有合理理由怀疑用户提供虚假交易信息的，上海屋聚有权暂时或永久限制用户所使用的产品或服务的部分或全部功能。' }
            ]
        },
        {
            name: '六、知识产权',
            list: [
                { text: '（一）上海屋聚所有电子及其他形式的相关信息，包括但不限于程序、著作、表格、图片、档案、资料、信函、电子租赁合同等均由上海屋聚或相关主体拥有知识产权。' },
                { text: '（二）非经上海屋聚书面同意，用户除使用账户功能需要外，不得复制、篡改、传播、发行或以任何其他形式向第三方披露。' }
            ]
        },
        {
            name: '七、免责声明',
            list: [
                { text: '（一）用户明确同意使用上海屋聚服务，所存在的风险将完全由其自己承担；因其使用上海屋聚服务而产生的一切后果也由其自行承担，上海屋聚对用户及其网上交易行为产生的影响不承担任何责任。' },
                { text: '（二）上海屋聚不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。' },
                { text: '（三）上海屋聚不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的任何页面上的内容不由上海屋聚实际控制，上海屋聚不承担任何责任。' }
            ]
        },
        {
            name: '八、违约责任',
            list: [
                { text: '用户因违反本协议及任何上海屋聚相关业务规则，均构成违约。因用户违约而给上海屋聚造成的损失的，上海屋聚有权扣收用户的账户余额、关联银行账户资金，并有权依法追究用户违约责任。' }
            ]
        },
        {
            name: '九、协议修改',
            list: [
                { text: '用户使用上海屋聚服务的行为表示同意，上海屋聚有权在必要时对本协议内容进行单方面的变更，并通过zuber 官网公布最新的协议，无需另行单独通知。若更新通知中未约定生效时间，更新后的协议条款一旦公布即代替原来的协议条款；若用户在本协议内容公告变更后继续使用本服务，则表示用户已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若不同意修改后的协议内容，用户应停止使用本服务。' }
            ]
        },
        {
            name: '十、法律适用与管辖',
            list: [
                { text: '本协议的订立、生效、变更、履行、解除、终止和解释以及由此产生的所有事项均适用中华人民共和国之法律、法规。涉及本协议履行过程中任何之争议，均由上海屋聚经营所在地人民法院管辖。' }
            ]
        },
        {
            name: '十一、通知和送达',
            list: [
                { text: '本协议项下所有的通知均可以网页公告、网页提示、手机短信、常规的信件传送、用户注册帐号的管理系统内发送站内信等方式中的一种或多种方式，向用户送达关于上海屋聚的各种规则、通知、提示等信息，该等信息一经上海屋聚采取前述任何一种方式公布或发送，即视为用户已经接受并同意，并对用户产生约束力。若用户不接受的，请立即停止使用上海屋聚，并书面通知上海屋聚，否则视为已经接受。' }
            ]
        },
        {
            name: '十二、其他规定',
            list: [
                { text: '本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。<br>如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>如本协议的条款与用户和上海屋聚另行签署的书面电子支付服务协议条款发生冲突，则以书面协议条款为准。' }
            ]
        }
    ]
}